module.exports = __webpack_public_path__ + "img/Delivery-Time.959437db.jpg";